import { Accordion as BootstrapAccordion } from "react-bootstrap";
import "style/requests.css";
import { Alert } from "react-bootstrap";
import CardRequestsAccordionItem from "../CardRequests.AccordionItem/CardRequests.AccordionItem";
import { Loader } from "ui";

const CardRequestsAccordion = ({
  data,
  dataKey,
  loading,
  tabKey,
  error,
  errorKey,
  items,
  cardFormat
}) => {
  return errorKey === tabKey && error && !loading ? (
    <Alert variant="danger">{error}</Alert>
  ) : dataKey === tabKey && data != null && !loading ? (
    <BootstrapAccordion className="text-left accordion_requests">
      {items.map((item, index) => (
        <CardRequestsAccordionItem
          key={index}
          {...{ item, index, tabKey, data, loading, cardFormat }}
        />
      ))}
    </BootstrapAccordion>
  ) : loading === true ? (
    <Loader variant="primary" size="md" className="position-absolute top-50">
      Loading...
    </Loader>
  ) : null;
};

export default CardRequestsAccordion;
